import { useMutation } from 'react-query'
import { apiPostManualVehicleTest } from '../api/manual-vehicle-test'

export const useAddManualVehicleTest = () => {
  return useMutation(({ payload }) => apiPostManualVehicleTest({ payload }))
}
